import React, { useEffect } from "react";

import getContentById from "../../../../shared/utils/getContentById";
import _ from "lodash";
import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, {
  animationCleanUp,
} from "./animation";
import PitchTactics from "../../_partials/PitchTactics/Index";

import assets from "./assets";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import countries from "../../../../../language/de/countries.json";
import { useTranslation } from "react-i18next";
// import outroVideo9x16 from "../../../assets/outros/outro_playoffs_9x16.webm";
import Image from "../../../../shared/components/Image";
import {
  getDynamicLogoPath,
  toIsoDateString,
} from "../../../../shared/utils/functions";
import { WcBgCircle } from "../../../../shared/backgrounds/WcBgCircle/Index";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/MatchScoreWidgetForBild";
import bild_zone_pitch from "../../../assets/wc/videos/lineup.webm";
import BildTeamLogo from "../../../../shared/components/Image/BildTeamLogo";
import PitchTacticsForBild from "../../_partials/PitchTactics/PitchTacticsForBild";
require("./style/style.scss");
require("./style/animation.scss");

const translations = {
  Group: "Gruppe",
};

const Index = (props) => {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const {
    animation,
    data,
    images: Images,
    apiSetup,
    mode,
    format,
    isTimeline,
  } = props;

  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;
  const { t } = useTranslation();

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup,
          templateName: data?.template_name,
        });
      }
    }

    //handle outro video BEGIN
    // if(mode === "video" && !isTimeline) {
    //   const outroVideo = $(`#${id} video.outro-optional-video`);
    //   outroVideo.get(0).addEventListener("loadedmetadata", function() {
    //       const that = this;
    //       setTimeout(()=> {
    //         outroVideo?.css('opacity', 1);
    //         this.currentTime = 0;
    //         that.play();
    //       }, frontendCfg.showOutroAfter)
    //     }, false);
    // }
    //handle outro video END

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const templateData = _.get(data, "data");

  const { options, fields, dynamic } = templateData;

  const matchInfo = _.get(dynamic, "matchInfo");
  const optaMatchInfo = _.get(dynamic, "optaMatchInfo");
  const lines = _.get(dynamic, "lines");
  const formation = _.get(dynamic, "formation");
  const lineups = _.get(dynamic, "lineup");

  const thisGameDate = new Date(
    toIsoDateString(matchInfo?.date, matchInfo?.time),
  );

  const homeTeam = matchInfo?.home;
  const awayTeam = matchInfo?.away;

  const teamSide = getContentById("selectedSide", fields);

  const teamId = teamSide === "home" ? homeTeam?.id : awayTeam?.id;

  const matchEvents = matchInfo?.match_event;
  const tactics = matchInfo?.tactical;
  const allPlayerMapping = dynamic?.allPlayerMapping;
  let lineup = []
  if (matchEvents) {
    lineup = matchEvents?.filter((e) => (e.kind === 'lineup' || e.kind === 'substitute-in'))
  } else {
    lineup = tactics?.filter((e) => e.team_id === teamId)
  }

  const optaHomeTeam = _.find(optaMatchInfo?.contestant, { position: "home" });
  const optaAwayTeam = _.find(optaMatchInfo?.contestant, { position: "away" });

  const lineupData =
    teamSide === "home"
      ? _.find(lineups, { contestantId: optaHomeTeam?.id })
      : _.find(lineups, { contestantId: optaAwayTeam?.id });
  const firstTeamOfficial = _.isArray(lineupData?.teamOfficial) ? lineupData?.teamOfficial?.[0] : lineupData?.teamOfficial;
  const coach = firstTeamOfficial?.firstName ? (
    <div>
      {firstTeamOfficial?.shortFirstName}{" "}
      {firstTeamOfficial?.shortLastName}
    </div>
  ) : (
    "-"
  );
  return (
    <div
      id={id}
      className={`T_${_.get(data, "template_name", "")} ${animation ? "animation" : ""} side-${_.get(dynamic, "teamSide")}`}
    >
      <TemplateBlock class={`${isTimeline ? "" : "template-bild"}`}>
        {
          !isTimeline && <div className="main-header-content">
            <div className="main-header">
              {t("Lineup", { keyPrefix: "templates" })}
            </div>
            <MatchScoreWidget
              homeTeam={homeTeam}
              awayTeam={awayTeam}
              matchInfo={matchInfo}
            />
          </div>
        }
        <div className={"wc-content wc-content-v2"}>
          <ProgressBar height={"8px"} />
          <div className="main-content-side">
            <div className={"left-block-side"}>
              <div className={"teams-block " + teamSide}>
                {teamSide === "home" ? (
                  <div className={"team-logo-container home"}>
                    <BildTeamLogo
                      className="team-logo"
                      id={homeTeam?.id}
                    />
                    <div className={"team-name home"}>
                      {formation?.split("")?.join("-")}
                    </div>

                    <div className="team-coach">
                      <div className="team-coach-placeholder">{t("Coach", { keyPrefix: "templates" })}</div>
                      {coach}
                    </div>
                  </div>
                ) : (
                  <div className={"team-logo-container away"}>
                    <BildTeamLogo
                      className="team-logo"
                      id={awayTeam?.id}
                    />
                    <div className={"team-name away"}>
                      {formation?.split("")?.join("-")}
                    </div>
                    <div className="team-coach">
                      <div className="team-coach-placeholder">{t("Coach", { keyPrefix: "templates" })}</div>
                      {coach}
                    </div>
                  </div>
                )}
              </div>
              <div className="left-block-shadow"></div>
            </div>
            <div className={"center-block-side"}>
              <div
                className={`attacking-zones`}
              >
                <video
                  className="video-pitch"
                  width="100%"
                  height="100%"
                  controls={false}
                  muted={true}
                  autoPlay={false}
                  loop={false}>
                  <source src={bild_zone_pitch} type="video/mp4" />
                </video>
              </div>
              <div className={"lineup"}>
                {
                  formation && lines &&
                  <PitchTacticsForBild
                    className={"lineup-pitch"}
                    formation={formation}
                    lines={lines}
                    trikot={assets.trikot}
                    side={teamSide}
                    teamId={teamId}
                    lineup={lineup}
                    allPlayerMapping={allPlayerMapping}
                  />
                }

              </div>
            </div>
          </div>
        </div>
      </TemplateBlock>
    </div>
  );
};

const getMainBackground = (format, side) => {
  return _.get(assets, `background_1920`);
};

export default Index;
